export const scheduleIdle = (callback: () => void): void => {
  if (typeof window === "undefined") return;
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(callback, { timeout: 4000 });
    return;
  }
  setTimeout(callback, 200);
};
